import { Capacitor } from '@capacitor/core';

/*
  WIDGET KOPRUSU
  --------------
  Ana ekran widget'i uygulamadan AYRI bir surectir; uygulamanin
  localStorage'ini goremez. iOS'ta iki surecin ortak veri alani
  "App Group" denen paylasilan bir kutudur.

  NEDEN DOGRUDAN APP GROUP'A YAZMIYORUZ: @capacitor/preferences
  eklentisi adindaki "group" ayarina ragmen iOS'ta App Group'a YAZMAZ —
  kaynagina bakildiginda her zaman UserDefaults.standard kullaniyor,
  "group" yalnizca anahtar adinin onune eklenen bir metin. Yani buradan
  yazilan deger widget'in goremedigi bir yerde kalir.

  BU YUZDEN IKI ADIMLI: burada jetonu uygulamanin kendi kutusuna
  yaziyoruz; uygulamanin yerli tarafi (SceneDelegate.swift) uygulama
  arka plana alinirken ya da one gelirken bu degeri App Group'a
  kopyaliyor ve widget'a "yenile" diyor. Kullanici zaten widget'a
  bakmak icin uygulamadan cikmak zorunda, dolayisiyla kopyalama tam
  dogru anda oluyor.

  ONEMLI: burada Preferences.configure CAGRILMAZ. O cagri eklentinin
  ayarini UYGULAMA GENELINDE degistiriyor ve Face ID'nin sakladigi
  jetonun okunamamasina yol aciyordu.

  GUVENLIK: App Group yalnizca ayni gelistirici hesabiyla imzalanmis
  uygulamalar tarafindan okunabilir; baska bir uygulama giremez.
*/

const ANAHTAR_JETON = 'widgetJeton';
const ANAHTAR_TUR = 'widgetTur';

const yerli = () =>
  typeof Capacitor?.isNativePlatform === 'function' && Capacitor.isNativePlatform();

/**
 * Oturum jetonunu widget'in okuyabilecegi yere hazirlar.
 * @param {string} jeton  Bearer jetonu
 * @param {'personel'|'muvekkil'} tur
 */
export const widgetJetonuYaz = async (jeton, tur) => {
  if (!yerli() || !jeton) return;
  try {
    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.set({ key: ANAHTAR_JETON, value: jeton });
    await Preferences.set({ key: ANAHTAR_TUR, value: tur });
  } catch (e) {
    /* Widget calismazsa uygulama calismaya devam etmeli. */
  }
};

/** Cikista jetonu siler; widget bir daha veri cekemez. */
export const widgetJetonuSil = async () => {
  if (!yerli()) return;
  try {
    const { Preferences } = await import('@capacitor/preferences');
    await Preferences.remove({ key: ANAHTAR_JETON });
    await Preferences.remove({ key: ANAHTAR_TUR });
  } catch (e) { /* yoksay */ }
};
